var chunkMapping = {
	"531": [
		39624
	],
	"967": [
		75153
	],
	"999": [
		47386
	],
	"1314": [
		93252
	],
	"3208": [
		40031
	],
	"4197": [
		73284
	],
	"4723": [
		20562
	],
	"7679": [
		92561
	],
	"8680": [
		81478
	],
	"9194": [
		36103
	],
	"9513": [
		12824
	]
};
var idToExternalAndNameMapping = {
	"12824": [
		"default",
		".",
		69534
	],
	"20562": [
		"default",
		"./open-notification",
		74278
	],
	"36103": [
		"default",
		".",
		92452
	],
	"39624": [
		"default",
		".",
		23048
	],
	"40031": [
		"default",
		".",
		15293
	],
	"47386": [
		"default",
		".",
		48059
	],
	"73284": [
		"default",
		".",
		66917
	],
	"75153": [
		"default",
		".",
		75018
	],
	"81478": [
		"default",
		".",
		74278
	],
	"92561": [
		"default",
		".",
		25132
	],
	"93252": [
		"default",
		".",
		34739
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}